<template>
  <v-container>
    <v-stepper v-model="e1">
      <v-card class="lime elevation-0 rounded-0" dark tile>
        <v-card-title>
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <h3 style="color:white">
            JOURNAL OF NUTRITION & DIETETICS
          </h3>
        </v-card-title>
      </v-card>
      <v-stepper-header class="elevation-0">
        <v-stepper-step
          :complete="e1 > 1"
          step="1"
          color="lime"
          v-if="step_one == true"
        ></v-stepper-step>
        <v-stepper-step
          :complete="e1 > 1"
          :rules="[() => false]"
          step="1"
          v-else-if="step_one == false"
        >
          Error
          <small>please correct</small>
        </v-stepper-step>
      </v-stepper-header>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 md12>
            <h3>
              {{ model.name }}
            </h3>
          </v-flex>
        </v-layout>
      </v-container>
      <v-stepper-items>
        <v-snackbar v-model="snackbar" :multi-line="mode" :right="x" :top="y">
          {{ snackbar_text }}
          <v-btn color="lime" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-stepper-content step="1">
          <form @submit.prevent="StepOne" v-if="downloaded == false">
            <v-card class="mb-5" color="grey lighten-4" height flat>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 md12>
                      <h4>AUTHORS</h4>
                    </v-flex>
                    <v-flex xs12 md12>
                      <div>{{ model.authors }}</div>
                    </v-flex>
                    <v-flex xs12 md12>
                      <h4>KEYWORDS</h4>
                    </v-flex>
                    <v-flex xs12 md12>
                      <div>{{ model.keywords }}</div>
                    </v-flex>
                    <v-flex xs12 md12>
                      <h4>ABSTRACT</h4>
                    </v-flex>
                    <v-flex xs12 md12>
                      <div>{{ model.article }}</div>
                    </v-flex>
                    <v-flex xs12 md12 v-if="model.status == 1"
                      ><br />
                      <br />
                      <br />
                    </v-flex>

                    <v-flex xs12 md12 v-if="model.status == 1">
                      <div>
                        This article can only be viewed fully once purchased.
                        You can make your payment using the following methods<br />
                        1. Via Bank Deposit.
                        <br />
                        <ul>
                          <li>Bank: Co-operative Bank of Kenya</li>
                          <li>
                            Account Name: Kenya Nutritionists and Dietician
                            Institute
                          </li>
                          <li>Account Number. 01128125024600</li>
                          <li>Branch: Nairobi Business Centre Branch</li>
                          Once you complete the payment kindly send a scanned
                          copy of your deposit slip to
                          kndijournal@kndi.institute
                        </ul>
                        <br />
                        2. Via M-PESA
                      </div>
                    </v-flex>
                    <v-flex xs12 md12 v-if="model.status == 1">
                      <h4>Phone Number</h4>
                    </v-flex>
                    <v-flex xs12 md12 v-if="model.status == 1">
                      <v-text-field
                        class="input-group--focused"
                        color="lime"
                        v-model="model.phone_number"
                        :error-messages="errors.phone_number"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md12 v-if="model.status == 1">
                      <h4>Email</h4>
                    </v-flex>
                    <v-flex xs12 md12 v-if="model.status == 1">
                      <v-text-field
                        class="input-group--focused"
                        color="lime"
                        v-model="model.email"
                        :error-messages="errors.email"
                      ></v-text-field>
                    </v-flex>
                    <v-btn
                      block
                      color="lime"
                      class="white--text"
                      @click.native="stkPush"
                      v-if="model.status == 1 && disabled == false"
                      >CLICK TO PAY VIA M-PESA</v-btn
                    >
                    <v-btn disabled v-if="disabled == true">
                      <v-progress-circular
                        :width="3"
                        :size="15"
                        indeterminate
                        color="white"
                      ></v-progress-circular
                      >&nbsp; submitting
                    </v-btn>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
            <a
              :href="model.document"
              style="text-decoration: none;"
              target="_blank"
              v-if="model.status == 2"
            >
              <v-btn block color="lime">Download Full Article</v-btn>
            </a>
          </form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-dialog v-model="downloaded" persistent width="300">
      <v-card color="lime" dark>
        <v-card-text>
          Processing
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Vue from "vue"
import { jndArticleUrl } from "@/config"
import axios from "axios"
import swal from "sweetalert2"
export default {
  data() {
    return {
      snackbar: false,
      snackbar_text: "",
      y: "",
      x: "",
      mode: "",
      e1: 0,
      e6: 1,
      disabled: false,
      step_one: true,
      downloaded: false,
      errors_training_interest: false,
      dialog: false,
      currentPage: 0,
      pageCount: 0,
      model: {},
      errors: {}
    }
  },
  beforeMount() {
    this.downloaded = true
    this.fetchData()
    this.dialog = false
  },
  methods: {
    fetchData() {
      var vm = this
      const data = {
        article_id: vm.$route.params.id
      }
      axios
        .post(jndArticleUrl, data)
        .then(function(response) {
          if (response.data.failed) {
            swal({
              title: "Not Found",
              text: "The article was not found in the database.",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          } else {
            Vue.set(vm.$data, "model", response.data)
            vm.downloaded = false
          }
        })
        .catch(function(error) {
          console.log(error.message)
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    stkPush() {
      var vm = this
      vm.disabled = true
      swal({
        title: "Info",
        text:
          "Check your phone and enter your MPESA pin to complete the Transaction.",
        type: "info",
        confirmButtonColor: "#cddc39",
        confirmButtonText: "OK"
      })
      vm.disabled = false
      window.location.href = "https://journal.kndi.institute/"
      /* var data = {
        email: vm.model.email,
        phone_number: vm.model.phone_number
      }

      const options = {
        method: "POST",
        //headers: getHeader(),
        data: data,
        url: stkPushArticleUrl
      }
      axios(options)
        .then(function(response) {
          if (response.data.stored) {
            swal({
              title: "Info",
              text:
                "Check your phone and enter your MPESA pin to complete the Transaction.",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            var counter = 0
            window.setIntervalSTK = setInterval(function() {
              counter += 1
              vm.stkPushQuery(response.data.bio_data)
              if (counter == 10) {
                clearInterval(setIntervalSTK)
              }
            }, 10000)
          } else {
            vm.disabled = false
          }
        })
        .catch(function(error) {
          console.log(error.message)
          vm.downloaded = false
          vm.disabled = false
          Vue.set(vm.$data, "errors", error.response.data)
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
            vm.disabled = false
            vm.sending = false
          }
        })*/
    },
    stkPushQuery(item) {
      var vm = this
      vm.disabled = true
      var data = {
        check_out_request_id: item
      }

      const options = {
        method: "POST",
        //headers: getHeader(),
        data: data,
        url: stkPushQueryArticleUrl
      }
      axios(options)
        .then(function(response) {
          if (response.data.stored) {
            if (response.data.result_code == 0) {
              swal({
                title: "Success",
                text:
                  "Your payment has been confirmed. Please check your email for your receipt.",
                type: "success",
                confirmButtonColor: "#cddc39",
                confirmButtonText: "OK"
              })
              clearInterval(setIntervalSTK)
              vm.clear_it()
              const authUser = window.$cookies.get("authUser")
              if (authUser && authUser.access_token) {
                vm.$router.push({ name: "dashboard" })
              }
            } else {
              swal({
                title: response.data.result_code,
                text: response.data.result_desc,
                type: "info",
                confirmButtonColor: "#cddc39",
                confirmButtonText: "OK"
              })
              clearInterval(setIntervalSTK)
            }
            vm.disabled = false
          }
        })
        .catch(function(error) {
          console.log(error.message)
          vm.downloaded = false
          vm.disabled = false
          Vue.set(vm.$data, "errors", error.response.data)
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
            vm.disabled = false
            vm.sending = false
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/jnd-article.vue